module.exports = "/images/gotham-14.jpg";